// @format
import PropTypes from 'prop-types';
import { compose, propEq } from 'ramda';
import { lifecycle, withStateHandlers } from 'recompose';

const MatchMedia = ({ children, isMatched }) => children(isMatched);

MatchMedia.propType = {
  children: PropTypes.func.isRequired,
  isMatched: PropTypes.bool,
};

export default compose(
  withStateHandlers(
    {
      isMatched: false,
    },
    {
      setIsMatched: () => matched => ({ isMatched: matched }),
    },
  ),
  lifecycle({
    componentDidMount() {
      const x = window.matchMedia(this.props.mediaQueries);
      this.props.setIsMatched(x.matches);
      x.addListener(compose(this.props.setIsMatched, propEq('matches', true)));
    },
  }),
)(MatchMedia);



// WEBPACK FOOTER //
// ./src/modules/components/MatchMedia/MatchMedia.js